import React from 'react';

import {ServerResponseHandler} from 'src/components/server-response-handler';

import Loading from '@pb/kit-component-loading';

import {ExternalLinksContext} from './external-links-context';
import {useExternalLinksConfig} from './useExternalLinksConfig';

export const ExternalLinksContextProvider = ({children}: {children: React.ReactNode}) => {
    const {
        isLoading,
        loadingError,
        data: externalLinksConfig,
    } = useExternalLinksConfig();

    if (isLoading) {
        return <Loading fast={true}/>;
    }

    return (
        <ServerResponseHandler serverError={loadingError}>
            <ExternalLinksContext.Provider value={externalLinksConfig}>
                {children}
            </ExternalLinksContext.Provider>
        </ServerResponseHandler>
    );
};
